import { Create, SimpleForm, useNotify, useRedirect } from "react-admin";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";
import BackButtonToolbar from "features/BackButtonToolbar";
import CreateSaveForm from "./CreateSaveForm";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { useNotifyError } from "utils/useNotifyError";

const CreateWeeklySchedule = () => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();

  const notify = useNotify();
  const redirect = useRedirect();

  const handleSave = async values => {
    try {
      await dataProvider.customRequest(studentRequests.createWeeklySchedule(), values, "POST");
      notify("Записът е създаден", { type: "success" });
      redirect(-1);
    } catch (err) {
      notifyError(err);
      handleConflictError(err);
    }
  };

  return (
    <>
      <Create
        title="Създаване на седмично разписание"
        actions={<BackButtonToolbar />}
      >
        <SimpleForm onSubmit={handleSave}>
          <CreateSaveForm />
        </SimpleForm>
      </Create>
      <ConflictErrorDialog />
    </>
  );
};

export default CreateWeeklySchedule;
